import { createAuthenticationContainer } from 'containers/Authentication/createAuthenticationContainer'

export const container = createAuthenticationContainer({
	path: '/:sessionId',
	getCountry: () => undefined,
})
